import { createAction } from 'redux-actions'
import logger from 'utils/logger'
import { types } from 'features/notifications/store/types'
import { utils } from 'gipsy-misc'
import { getUnreadNotificationsOfTasks, getUnreadNotificationsByType } from 'features/notifications/utils'

export const setNotifications = createAction(types.SET_NOTIFICATIONS)
const _setNotificationsRead = createAction(types.SET_NOTIFICATIONS_READ)

export const get = () => async (dispatch, getState, { api }) => {
  try {
    const notifications = await api.notifications.get()
    dispatch(setNotifications(notifications))
    return notifications
  } catch (err) {
    logger.error(err)
  }
}

export const setNotificationsRead = notifications => async (dispatch, getState, { api }) => {
  const ids = notifications.map(n => (typeof n === 'string' ? n : n.id))
  if (!ids || !ids.length) {
    return
  }
  await api.notifications.markAsRead(ids)

  dispatch(
    _setNotificationsRead({
      ids,
      read: 1
    })
  )
}

export const markReorderTaskNotifsAsRead = () => async (dispatch, getState, { api }) => {
  const notifications = getUnreadNotificationsByType(getState().notifications.list, utils.notifications.reorderTaskType)
  await dispatch(setNotificationsRead(notifications))
}

export const markArchiveTasksWithUpdatesAsRead = () => async (dispatch, getState, { api }) => {
  const withUpdateTasks = getState().todolist.items.archiveWithUpdates.list
  const notifications = getUnreadNotificationsOfTasks(getState().notifications.list, withUpdateTasks)
  await dispatch(setNotificationsRead(notifications))
}

export const markTeamTasksWithUpdatesAsRead = () => async (dispatch, getState, { api }) => {
  const withUpdateTasks = getState().teamlist.items.updates.list
  const notifications = getUnreadNotificationsOfTasks(getState().notifications.list, withUpdateTasks)
  await dispatch(setNotificationsRead(notifications))
}

export const markTaskAsRead = id => async (dispatch, getState, { api }) => {
  const notifications = utils.notifications
    .getUnreadNotificationsByTaskId(getState().notifications.list, id)
    .map(n => n.id)
  await dispatch(setNotificationsRead(notifications))
  return notifications.length
}



// WEBPACK FOOTER //
// ./src/features/notifications/store/actions.js